import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('elrc_theme') || 'dark'; } catch { return 'dark'; }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('theme-switching');
    document.documentElement.setAttribute('data-theme', theme);

    // Mantener transiciones solo mientras el tema está mutando.
    const timeoutId = window.setTimeout(() => {
      root.classList.remove('theme-switching');
    }, 520);

    try { localStorage.setItem('elrc_theme', theme); } catch {}
    return () => window.clearTimeout(timeoutId);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
